import { render, staticRenderFns } from "./g-font.vue?vue&type=template&id=acee2ed0"
import script from "./g-font.vue?vue&type=script&lang=js"
export * from "./g-font.vue?vue&type=script&lang=js"
import style0 from "./g-font.vue?vue&type=style&index=0&id=acee2ed0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports